import React from "react";
import AbstractItemsTableWithLoader from '../Tables/AbstractItemsTableWithLoader';
import {fetchFeedbackMovements} from '../services';
import {Link} from 'react-router-dom';

const FeedbackMovementsTable = () => {

    const tableColumns = {
        keyFormatted: 'ID',
        date: {
            name: 'Date',
            style: {
                width: '180px',
            },
        },
        type: 'Type',
        status: 'Status',
        amount: 'Amount',
        currency: 'Currency',
        name: 'Name',
        account: 'Account',
        feedbackFile: {
            name: 'FeedbackFile',
            style: {
                width: '210px',
            },
        },
        communication: 'Communication',
    };

    const namedSearchParameters = {
        dateCreated: {
            type: 'date',
            name: 'Created date',
            operators: ['eq', 'lt', 'gt', 'between'],
        },
        lastUpdated: {
            type: 'date',
            name: 'Last updated date',
            operators: ['eq', 'lt', 'gt', 'between'],
        },
        feedbackFileCreated: {
            type: 'date',
            name: 'Feedback date',
            operators: ['eq', 'lt', 'gt', 'between'],
        },
        feedbackFileIban: {
            type: 'text',
            name: 'IBAN',
            operators: ['eq', 'contains'],
        },
        status: {
            type: 'select',
            name: 'Status',
            options: ['UNHANDLED', 'MARKED_AS_HANDLED', 'REFUNDED', 'FORWARDED', 'IGNORED'],
            operators: ['eq'],
            multiple: true,
        },
        type: {
            type: 'select',
            name: 'Type',
            options: ['CREDIT', 'DEBIT'],
            operators: ['eq'],
            multiple: true,
        },
        communication: {
            type: 'text',
            name: 'Communication',
            operators: ['eq', 'contains'],
        },
    };

    const fetchFunction = (searchParams: any) => {
        return fetchFeedbackMovements(searchParams).then(data => ({
            ...data,
            items: data.items.map((item: any) => ({
                ...item,
                keyFormatted: <Link to={`/feedback-movements/${item.key}`}>{item.key}</Link>,
                feedbackFile: (<div>
                    <div>IBAN: {item.feedbackFileIban}</div>
                    <div>Opening Balance: {item.openingBalance}</div>
                    <div>Closing Balance: {item.closingBalance}</div>
                    <div>FeedbackDate: {item.feedbackFileCreated}</div>
                </div>),
                date: (<div>
                    <div>Created: {item.dateCreated}</div>
                    <div>Last updated: {item.lastUpdated}</div>
                </div>),
            })),
        }));
    };

    return <AbstractItemsTableWithLoader
        tableColumns={tableColumns}
        namedSearchParameters={namedSearchParameters}
        fetchFunction={fetchFunction}
        autoWidthColumns={['keyFormatted', 'type', 'status', 'amount', 'currency', 'name', 'account', 'communication']}

    />;
};

export {
    FeedbackMovementsTable
};
